module.exports = __webpack_public_path__ + "static/media/icon_business.ead111ee.svg";